import { render, staticRenderFns } from "./SwitchCompanyFromViewTicketViaTemplate.vue?vue&type=template&id=0c203854"
import script from "./SwitchCompanyFromViewTicketViaTemplate.vue?vue&type=script&lang=js"
export * from "./SwitchCompanyFromViewTicketViaTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports